import { useEffect, useState } from "react";
import { ThemeEnum, ThemeType } from "./types";

// Helper function to check if matchMedia is supported
function checkSupportForMatchMedia() {
    if (typeof window === "undefined" || !window.matchMedia) {
        console.warn("matchMedia is not supported in this environment.");
        return false;
    }
    return true;
}

export function useTheme() {
    const [theme, setTheme] = useState<ThemeType | null>(null);

    const applyTheme = (mode: ThemeType) => {
        setTheme(mode);
        localStorage.setItem("theme", mode);

        function setBodyClass() {
            const mql = window.matchMedia("(prefers-color-scheme: dark)");

            const shouldUseDark = mode === ThemeEnum.DARK || (mode === ThemeEnum.SYSTEM && mql.matches);
            document.documentElement.classList.toggle(ThemeEnum.DARK, shouldUseDark);
        }
        setBodyClass();
    };

    useEffect(() => {
        if (!checkSupportForMatchMedia()) return;        

        const loadThemeFromStorage = () => {
			const storedTheme = localStorage.getItem("theme") as ThemeType;

			if (
				storedTheme === ThemeEnum.DARK ||
				storedTheme === ThemeEnum.LIGHT ||
				storedTheme === ThemeEnum.SYSTEM
			) {
				applyTheme(storedTheme);
			} else {
				applyTheme(ThemeEnum.DEFAULT);
			}
		};

        loadThemeFromStorage();       

    }, []);

    const toggleTheme = () => {
        let next: ThemeType;

        if (theme === ThemeEnum.LIGHT) next = ThemeEnum.DARK;
        else if (theme === ThemeEnum.DARK) next = ThemeEnum.SYSTEM;
        else next = ThemeEnum.LIGHT;

        applyTheme(next);
    };

    return { theme, toggleTheme, applyTheme };
}
